import * as React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Link, PageTitle, SectionHeader } from '@/components/common';
import { FAQs } from '@/components/marketing';

const HelpPage: NextPage = () => {
  return <>
      <NextSeo title='Support' />
      <PageTitle>Support</PageTitle>
      <div className='space-y-8 md:space-y-12'>
        {
        /* <SectionHeader
         description={
           <>
             For quick questions, text a member of our team in real time.{' '}
             <Link className='whitespace-nowrap' href='tel:3057873446'>
               (305) 787 3446
             </Link>
           </>
         }
         title='Text'
        /> */
      }
        <SectionHeader description={<>
              For technical issues, to report a bug or if you have questions about your account, please email our
              support team <Link href='mailto:support@28.co'>support@28.co</Link>.
            </>} headingChildren={<h3 className='font-lato text-2xl md:text-3xl uppercase tracking-tight font-bold bg-clip-text text-transparent bg-gradient-yellow-to-purple'>
              Email
            </h3>} />
        <SectionHeader description='Our Most Frequently Asked Questions' title='F.A.Q.' />
        <FAQs />
      </div>
    </>;
};

export default HelpPage;